import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { trackVisit } from "./lib/analytics.ts";
import "./index.css";

// One `visit` per page load. At module scope rather than in an effect, so a
// React StrictMode double-mount in development cannot report the same load
// twice, and so the stored `lastVisitAt` is rolled forward exactly once.
// Safe to run before render: the analytics module no-ops without a beacon.
trackVisit();

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
